import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=44dc484d&scoped=true&"
import script from "./CategoriesTable.vue?vue&type=script&lang=js&"
export * from "./CategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTable.vue?vue&type=style&index=0&id=44dc484d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc484d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
